"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceUnderscore = void 0;
/**
 * - If string contain underscore(_) it will replace by space and return.
 *
 * @param {string} string - The value to be formatted.
 * @returns {string} - The formatted string, or original/empty string based on conditions.
 */
const replaceUnderscore = (string) => {
    if (!string)
        return string;
    return string.replace('_', ' ');
};
exports.replaceUnderscore = replaceUnderscore;
